export default {
  white: '#fff',
  black: '#111',
  red: '#e54d42',
  green: '#11b22c',
  orange: '#FF7700',
  orangeDark: '#FF6400',
  whiteBackground: '#F5F5F5', // '#e8ecee',
  sidebarBackground: '#222d37',
  noticeBackround: 'rgba(69, 193, 60, .3)',
  inputColor: '#555555',
  labelColor: '#848888',
  CTA: '#FF7700',
  CTA_alt: '#FFDDBF',
};